/**
 * Store item to localStorage with an expiry.
 *
 * Useful future offset values:
 *   oneHour = 3.6e6; // ie, 60 * 60 * 1000
 *   oneDay = 86.4e6; // ie, 24 * 60 * 60 * 1000
 *   oneWeek => 604.8e6; // ie, 7 * 24 * 60 * 60 * 1000
 *
 * @param {string} key the string name of the variable to store.
 * @param {any} value the value to store.
 * @param {int} ttl a timestamp indicating when the item expires.
 */
const setWithExpiry = (key, value, ttl) => {
  const now = new Date().getTime();
  const item = {
    value: value,
    expiry: now + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

/**
 * Retrieve item from localStorage with a lazy expiry calculation.
 *
 * @param {string} key the string name of the variable to retrieve.
 */
const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date().getTime();
  // compare the expiry time of the item with the current time
  if (now > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export { setWithExpiry, getWithExpiry };
